export default __webpack_public_path__ + "static/media/primordial_jade_cutter.1485610d.png";